// extracted by mini-css-extract-plugin
export var container = "_ft-0";
export var icon = "_ft-1";
export var text = "_ft-2";